// @flow
import apiService from './auth-api-service';

class CaredoveIntegrationService {
  connectCaredove = (token, socketId) => {
    if (!token) {
      return Promise.reject('No referral token was provided');
    }
    return apiService.post('/integrations/connect/caredove', {
      token,
      socketId
    });
  };
}

export default new CaredoveIntegrationService();


// WEBPACK FOOTER //
// ./src/services/caredove-integration-service.js